export default __webpack_public_path__ + "static/media/personal.65faf897.svg";